<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <!-- <div class="man-cell" style="width:350px">
        <el-date-picker
          v-model="stime"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </div>
      <el-button type="primary" @click="changeData(stime[0],stime[1])">搜索</el-button> -->
      <el-table :data="tableData" highlight-current-row style="width:100%" v-loading="loading">
        <el-table-column property="username" label="邀请用户"></el-table-column>
        <el-table-column property="sum" label="累计收益"></el-table-column>
        <el-table-column property="vip" label="会员等级">
          <template slot-scope="scope">
            {{ scope.row.vip == 0 ? "非会员" : "" }}
            {{ scope.row.vip == 1 ? "普通会员" : "" }}
            {{ scope.row.vip == 2 ? "会员" : "" }}
            {{ scope.row.vip == 3 ? "超级会员" : "" }}
          </template>
        </el-table-column>
        <el-table-column property="vipPercent" label="增幅比例">
          <template slot-scope="scope">
            <el-button @click="onVipPercent(scope.row)">{{ scope.row.vipPercent }}</el-button>
          </template>
        </el-table-column>
        <el-table-column property="sum" label="累计收益"></el-table-column>
        <el-table-column property="createTime" label="创建时间"></el-table-column>
      </el-table>
      <div class="Pagination" style="text-align: left;margin-top: 10px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="index"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="count"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="修改增幅比例" :visible.sync="dialogVisible" width="40%">
      <el-form ref="form" label-width="100px">
        <el-form-item label="增幅比例" style="  clear: both;">
          <el-input-number :controls="false" :min="0" :max="100" v-model="editItem.vipPercent"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateVipPercent">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HeadTop from "../components/HeadTop";
import myAxios from "../myAxios";

export default {
  data() {
    return {
      stime: ["", ""],
      editItem:{},
      dialogVisible:false,
      username: localStorage.getItem("username"),
      tableData: [], //用户列表数据
      index: 1, //页码
      size: 20, //页大小
      count: 0, //数据总数
      loading: false, //加载状态
      sousuo: ""
    };
  },
  components: {
    HeadTop
  },
  created() {
    this.initData();
  },
  methods: {
    updateVipPercent(){
      myAxios
        .get(
          `client_user/UpdateVipPercent/v1?username=${this.editItem.username}&vipPercent=${this.editItem.vipPercent}`
        )
        .then(res => {
          this.dialogVisible=false
          this.initData()
        });
    },
    onVipPercent(item){
      this.editItem=JSON.parse(JSON.stringify(item))
      this.dialogVisible=true
    },
    async initData() {
      try {
        this.getrecharge();
      } catch (err) {
        console.log("获取数据失败", err);
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.index = val;
      this.getrecharge();
    },
    async getrecharge() {
      myAxios
        .get(
          `client_user/MyInviteUsers/v1?username=${this.username}&index=${this.index}&size=${this.size}`
        )
        .then(res => {
          this.tableData = res.data;
          this.count = res.total;
        });
      this.loading = false;
    },
    changeData(time1, time2) {
      myAxios
        .get(
          `client_media/TransferList/v1?username=${this.username}&starTime=${time1}&endTime=${time2}&index=${this.index}&size=${this.size}`
        )
        .then(res => {
          this.tableData = res.data;
          this.count = res.total;
        });
      this.loading = false;
    }
  }
};
</script>

<style lang="less">
@import "../style/mixin";
.table_container {
  padding: 20px;
}
.man-cell {
  width: 200px;
  float: left;
  margin-right: 20px;
}
</style>
